import { useViewShowChecker } from 'ducks/viewMode'
import React, { PropsWithChildren } from 'react'

type UiContainerPropsType = {
  uiKey: string
  children?: React.ReactNode | ((rest: Record<string, unknown>) => React.ReactNode)
}

/**
 * This component is a basic compntainer with a UI key, to allow it to
 * be hidden/shown using the view mode system.
 */

export const UiSwitch: React.FunctionComponent<PropsWithChildren<UiContainerPropsType>> = ({
  uiKey,
  children,
  ...rest
}) => {
  const show = useViewShowChecker(uiKey)

  if (!show) return <></>
  else if (typeof children === 'function') return (children as (rest: Record<string, unknown>) => React.ReactNode)(rest)
  else return children
}
